import { IYookassaDepositAmountLinkedCardOnclickResponseError } from '../../../../repositories/billing-accounts/v1/yookassa/deposit-amount-linked-card-onclick';
import { IMakeYooKassaLinkedCardPaymentError } from '../types';

export const mapResponse400 = (
  response: IYookassaDepositAmountLinkedCardOnclickResponseError,
): IMakeYooKassaLinkedCardPaymentError => {
  const { message } = response;

  return {
    isSuccess: false,
    error: message,
  };
};
